/** 与后端 GraphQL 枚举 DspPaymentMethod 保持一致 */
export type DspPaymentMethod = 'ONLINE_RECONCILIATION' | 'OFFLINE_RECONCILIATION';

export const DSP_PAYMENT_METHOD_OPTIONS: { value: DspPaymentMethod; labelKey: string }[] = [
    { value: 'ONLINE_RECONCILIATION', labelKey: 'dspBillPayment.paymentMethod.ONLINE_RECONCILIATION' },
    { value: 'OFFLINE_RECONCILIATION', labelKey: 'dspBillPayment.paymentMethod.OFFLINE_RECONCILIATION' }
];

/** 付款方式对应的 i18n 键；空值（未记录）返回 null，由调用方展示 '-' */
export function paymentMethodLabelKey(v?: DspPaymentMethod | null): string | null {
    return DSP_PAYMENT_METHOD_OPTIONS.find(option => option.value === v)?.labelKey ?? null;
}
